import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { getAccessToken } from '../core/services/auth.service';
import { AuthenticationDataService } from '../data/services/authentication/authentication-data.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authenticationDataService: AuthenticationDataService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !request.url.startsWith(environment.apiRoot) ||
      request.url === `${environment.apiRoot}/auth` ||
      request.url === `${environment.apiRoot}/request-password-reset` ||
      request.url === `${environment.apiRoot}/reset-password` ||
      request.url.startsWith(`${environment.apiRoot}/refresh`) ||
      request.url.startsWith(`${environment.apiRoot}/registration`) ||
      request.url === `${environment.apiRoot}/users/user`
    ) {
      return next.handle(request);
    }

    return next.handle(this.attachTokenToRequest(request, getAccessToken()!)).pipe(
      catchError(err => {
        if (err.status !== 401) {
          throw err;
        }
        return this.authenticationDataService.refreshToken().pipe(
          switchMap(() => {
            return next.handle(this.attachTokenToRequest(request, getAccessToken()!));
          }),
          catchError(() => {
            if (err.status !== 401) {
              throw err;
            }
            if (!this.router.url.endsWith('/registration')) {
              void this.router.navigate(['/login']);
            }
            throw Error('no valid token');
          })
        );
      })
    );
  }

  private attachTokenToRequest(
    request: HttpRequest<any>,
    token: string
  ): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
}
